<template>
  <div class="add-news">
    <a-modal title="添加资讯" :visible="true" :width="1200" :maskClosable='true' @ok="submitKeyAction" @cancel='modelCancel'>
      <a-form :form="form">
        <a-row type="flex" style="width: 100%;">
          <a-col :sm="24" :md="24" :lg="24" :xl="24">
            <!-- 资讯标题 -->
            <a-form-item label="资讯标题：" v-bind='addFormItemLayout1'>
              <a-input :maxLength="40" 
                v-decorator="['title', { 
                  rules: [{ required: true, message: '资讯标题不能为空' }], initialValue: initTitle,
                }]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="12" :xl="12">
            <!-- 资讯类别 -->
            <a-form-item label="资讯类别：" v-bind='addFormItemLayout2'>
              <a-select v-decorator="['classify', { 
                  rules: [{ required: true, message: '资讯类别不能为空' }], initialValue: initClassify,
                }]" style="width:120px;">
                <a-select-option value="公司快讯">公司快讯</a-select-option>
                <a-select-option value="产业快讯">产业快讯</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="12" :xl="12">
            <!-- 是否原创 -->
            <a-form-item label="是否原创：" v-bind='addFormItemLayout2'>
              <a-radio-group v-decorator="['isoriginal', { 
                  rules: [{ required: true, message: '是否原创不能为空' }], initialValue: initIsoriginal,
                }]">
                <a-radio :style="radioStyle" value="true">是</a-radio>
                <a-radio :style="radioStyle" value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="12" :xl="12">
            <a-form-item label="资讯来源：" v-bind='addFormItemLayout2'>
              <a-input style="width:120px;" :maxLength="10" 
                v-decorator="['newsFrom', { 
                  rules: [{ required: true, message: '资讯来源不能为空' }], initialValue: initNewsFrom,
                }]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="12" :xl="12">
            <a-form-item label="是否置顶：" v-bind='addFormItemLayout2'>
               <a-radio-group v-decorator="['isTop', { 
                  rules: [{ required: true, message: '请选择是否置顶' }], initialValue: initIsTop,
                }]">
                <a-radio :style="radioStyle" value="true">是</a-radio>
                <a-radio :style="radioStyle" value="false">否</a-radio>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :sm="12" :md="12" :lg="12" :xl="12">
            <a-form-item  v-bind='addFormItemLayout2'  label="发布时间">
              <a-date-picker 
              v-decorator="['publishTime', 
              {
                  rules: [
                    { required: true, message: '发布时间不能为空' },
                  ],
                  initialValue: initPublishTime
              }
              ]"></a-date-picker>
          </a-form-item>
        </a-col>
          <a-col :sm="24" :md="24" :lg="24" :xl="24">
            <a-form-item label="封面图片" v-bind="addFormItemLayout1">
              <div class="upload-box">
                  <a-upload
                    v-decorator="[
                      'imageUrl',
                      { rules: [{ required: true, message: '请上传封面图片' }], initialValue: imageUrl}
                    ]"
                    accept=".bmp,.gif,.jpg,.pic,.png,.jpeg"
                    name="file"
                    :multiple="false"
                    :showUploadList="false"
                    :action="doUpload"
                    :headers="headers"
                    @change="handleChange"
                  >
                  <a-button> <a-icon type="upload" /> 上传 </a-button>
                </a-upload>
              </div>
              <div class="img-list" v-if="imageUrl">
                <div class="img">
                    <img :src="imageUrl">
                </div>
                <div class="mask">
                    <a-icon type="eye" @click="preview(imageUrl)"/>
                </div>
              </div>
            </a-form-item>
          </a-col>
          <a-col :sm="24" :md="24" :lg="24" :xl="24">
                <div id="editor" ref="editor"></div>
           </a-col>
        </a-row>
      </a-form>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
          <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-modal>

  </div>
</template>
<script>
import Wangeditor from 'wangeditor'

import {addNews, editNews} from '@/api/news'
import { getToken } from "@/utils/auth";
import {formatDate} from '@/utils/date';
import moment from 'moment';

export default {
  props: {
    ifAdd: Boolean,
    editId: Number,
    detailObj: Object
  },
  components: { },
  data(){
    return{
      form: this.$form.createForm(this),
      addFormItemLayout1:{
        labelCol: {
            span: 3
        },
        wrapperCol: {
            span: 20,
            offset:1
        },
      },
      addFormItemLayout2:{
        labelCol: {
            span: 6
        },
        wrapperCol: {
            span: 16,
            offset:2
        },
      },
      radioStyle: {
        height: '30px',
        lineHeight: '30px',
      },
      msgCentent: '',
      doUpload: "/api/ossPublicConfig", //上传文件api
      headers: {},
      previewVisible: false,
      previewImage: '',
      imageUrl: '',
      initTitle: '',
      initClassify: '公司快讯',
      initIsoriginal: 'true',
      initNewsFrom: '宏恩网络',
      initIsTop: 'false',
      editorData: '',
      initPublishTime: null,
      editor: null,
    }
  },
  created() {
    this.init();
    if (!this.ifAdd) {
      this.initTitle = this.detailObj.title;
      this.initClassify = this.detailObj.classify;
      this.initIsoriginal = String(this.detailObj.isoriginal);
      this.initNewsFrom = this.detailObj.newsFrom;
      this.imageUrl = this.detailObj.imageUrl;
      this.editorData = this.detailObj.content;
      this.initIsTop = String(this.detailObj.isTop);
      this.initPublishTime = moment(this.detailObj.publishTime).format('YYYY-MM-DD');
    }
  },
  mounted() {
    this.initEditor()
  },
  methods: {
    modelCancel() {
      this.$emit("hideAction"); 
    },
    init() {
      let token = getToken();
      this.headers.Authorization = "Bearer " + token; //上传文件绑定Token  ie10以下不能使用
    },
    initEditor() {
      const editor = new Wangeditor(this.$refs.editor);
      let token = getToken();
      editor.config.height = 400
      editor.config.showLinkImg = false
      editor.config.excludeMenus = [
        'emoticon',
        'video'
      ]
      editor.config.uploadImgServer = '/api/ossPublicConfig' // 上传图片的接口地址
      editor.config.uploadFileName = 'file' // formdata中的name属性
      editor.config.debug = true // 开启debug模式
      editor.config.uploadImgMaxLength = 1 // 一次最多上传 1 个图片
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024 // 10M
      editor.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
      editor.config.uploadImgHeaders = {
        Authorization: "Bearer " + token // 设置请求头
      }
      editor.config.uploadImgHooks = {
        // 图片上传并返回结果，但图片插入错误时触发
        fail: function (xhr, editor, result) {
          console.log(result)
        },
        success: function (xhr, editor, result) {
        },
        customInsert: function(insertImgFn, result) {
          // insertImgFn 可把图片插入到编辑器，传入图片 src ，执行函数即可
          insertImgFn(result.inlineUrl);
        }
      }
      // 配置 onchange 回调函数，将数据同步到 vue 中
      editor.config.onchange = (newHtml) => {
        this.msgCentent = newHtml
      }
      // 创建编辑器
      editor.create();
      this.editor = editor
    },
    handleChange(data) {
      if (data.file.status == "done") {
        this.imageUrl = data.file.response.inlineUrl;
        this.$message.success("文件上传成功");
      } else if (data.file.status == "error") {
        this.$message.error("文件上失败，请重新上传！");
      } else if (data.file.status == "removed") {
        
      }
    },
    // 预览 word 和 PDF 时
    wordPreviewUrl(url) {
      if (url && url[0] === '/') {
        return window.location.origin + url;
      } else {
        return url;
      }
    },
    preview(url){
        this.previewVisible = true;
        this.previewImage = this.wordPreviewUrl(url);
    },
    handleCancel() {
      this.previewVisible = false;
    },
    submitKeyAction() {
        this.form.validateFields((err, params) => {
        if(!err){
          this.submitAction(params);
        }
      })
    },
    submitAction(obj) {
      if (!this.msgCentent) {
        this.$message.error('资讯正文不能为空');
        return false;
      }
      obj.publishTime = Date.parse(formatDate(new Date(obj.publishTime._d),"yyyy-MM-dd"));
      let params = {
            classify: obj.classify,
            content: this.msgCentent,
            isoriginal: obj.isoriginal,
            newsFrom: obj.newsFrom,
            title: obj.title,
            imageUrl: this.imageUrl,
            isTop: obj.isTop,
            publishTime: obj.publishTime
        }
        if (!this.ifAdd) {
          params.id = this.editId;
            editNews(params)
              .then(res => {
                this.$message.success('修改成功');
                  this.$emit('successAction');
                })
                .catch(error => {
                  console.log(error);
                })
        } else {
           addNews(params)
              .then(res => {
                  this.$message.success('添加成功');
                  this.$emit('successAction');
              })
              .catch(error => {
                  console.log(error);
              })
        }
    },
  },
  beforeDestroy() {
    // 调用销毁 API 对当前编辑器实例进行销毁
    this.editor.destroy()
    this.editor = null
  }
}
</script>
<style lang="less" scoped>
  #editor {
    width: 99%;
    margin: 0 auto;
  }
  .ant-form-item{
      margin-bottom:12px;
  }
  .upload-box {
      width: 100px;
      height: 100px;
      display: inline-block;
  }
  .img-list {
      width: 150px;
      height: 100px;
      text-align: center;
      position: relative;
      margin-left: 30px;
      display: inline-block;
      .img {
          width: 100%;
          height: 100%;
          img {
              width: 100%;
              height: 100%;
          }
      }
      .mask {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(101, 101, 101, 0.6);
          color: #ffffff;
          opacity: 0;
          font-size: 24px;
          line-height: 100px;
      }
  }
  .img-list:hover .mask {
      opacity: 1;           
  }
</style>